import React, { createContext } from "react";
let sTypes = {
  desktop: false,
  tablet: false,
  mobile: false,
};
const ScreenType = createContext(sTypes);
export { ScreenType };
